export default {
  name: 'ProgressControl',
  data() {
    return {
      //班级介绍
      introduction: {
        //选中班级名字
        name: "",
      },
      fileList: [],
      //上传文件
      action: this.baseUrl + 'file/upload_class?token=' + this.$store.state.id,
      file: '',
      // 服务器返回的文件名字
      fileName: '',
      // 上传选择的文件名
      realName: '',
      //班级公告
      bulletin: '',
      openDelay:500,
      //弹框表单input的宽度
      formLabelWidth:'100px',
      //学生情况的弹框
      dialogVisible:false,
      //当前弹框学生的id
      studentId:'',
      classDetails: {},
      //项目详情
      projectDetails:{},
      //班级列表
      classlisttwo: [],
      //成员列表
      MemberListTwo: [],
      //班级id
      classIdFlag:[],
      //评价标记
      createFlag:0,
      //学生的成绩和评价
      studentMark:{
        grade:'',
        comment:'',
      },
      //修改前分数
      beforeUp:{
        evaluates_grade:'',
        evaluates_content:'',
      },
      resources: [
        // {id: 1, name: '任务一', timu: '任务一的题目'},
        // {id: 2, name: '任务二', timu: '任务二的题目'}
      ],
      Catalogue: [
        // {id: 1, name: '活动一的题目'},
        // {id: 2, name: '活动一的题目'},
        // {id: 3, name: '活动一的题目'},
        // {id: 4, name: '活动一的题目'}
      ],
      id: '',
      seen: false,
      classSreach: '',
      bulletin: '',
      classStuSreach:'',
      //项目任务
      assignment: [],

      outline:[],
    }
  },
  methods: {

    // 确认上传文件
    confirmUploadFile() {
      // 发送公告时判断简报和附件的内容是否为空，依次调用相应接口，内容空不调用接口
      // 接口class_bulletin/create为简报的接口
      // 接口class_file/create为附件的接口
      if (this.bulletin !== '' && this.fileName !== '') {
        this.$post('class_bulletin/create', { token: this.$store.state.id, class_id: this.id, bulletin: this.bulletin }).then(res => {
          if (res.data.status == 'success') {
            // // console.log('简报上传成功')
          }
        })
        this.$post('class_file/create', { token: this.$store.state.id, class_id: this.id, file_name: this.realName, file_as_name: this.fileName }).then(res => {
          if (res.data.status == 'success') {
            // // console.log('附件上传成功')
          }
        })
        UIkit.modal(document.querySelector('#modal-sendNotice')).hide();

      } else if (this.bulletin == '' && this.fileName !== '') {
        this.$post('class_file/create', { token: this.$store.state.id, class_id: this.id, file_name: this.realName, file_as_name: this.fileName }).then(res => {
          if (res.data.status == 'success') {
            // // console.log('附件上传成功')
          }
        })
        UIkit.modal(document.querySelector('#modal-sendNotice')).hide();
      } else if (this.bulletin !== '' && this.fileName == '') {
        this.$post('class_bulletin/create', { token: this.$store.state.id, class_id: this.id, bulletin: this.bulletin }).then(res => {
          // // console.log(res)
          if (res.data.status == 'success') {
            // // console.log('简报上传成功')
          }
        })

        UIkit.modal(document.querySelector('#modal-sendNotice')).hide();
      }
      else {
        this.$message.error('简报和附件不能都为空');
      }
    },
    // 上传成功后返回的值
    handleSuccess(response, file, fileList) {
      this.fileName = response.result
      this.realName = file.name
    },
    // 限制上传文件个数的警告方法
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },

    //打开公告的界面
    sendNotice() {
      if (this.introduction.name == '') {
        this.$message.error('请先选择班级');
      } else {
        // 清空简报、文件名、服务器返回的文件名和附件后显示窗口
        this.bulletin = '';
        this.realName = '';
        this.fileName = '';
        this.fileList = [];
        UIkit.modal(document.querySelector('#modal-sendNotice')).show();
      }

    },

    //关闭公告的界面
    cancel() {
      UIkit.modal(document.querySelector('#modal-sendNotice')).hide();
    },


    //点击学员操作按钮
    studentControl(obj,type){
      // // console.log(obj)
      this.createFlag = type;
      this.beforeUp = obj;
     this.dialogVisible = true
     this.studentId=obj.id;
    },
    //确定评分和评价操作
    confirmControl(){
      let grade = this.studentMark.grade;
      let reg = new RegExp([/^[0-9]*$ /]) ;
      // let reg1 =  new RegExp([/^((0{1}\.\d{1,2})|([1-9]\d*\.\d{1,2})|([1-9]+\d*)|0)$/]);
      if(reg.test(grade)){
        this.$message({
          message:'评分格式错误！',
          type:'error',
        })
        return false
      }
      // if(!reg1.test(grade)){
      //   this.$message({
      //     message:'分数范围错误！',
      //     type:'error',
      //   })
      //   return false
      // }
      let data={
        user_id:this.studentId,
        class_id:this.id,
        grade:this.studentMark.grade,
        content :this.studentMark.comment,
        token:this.$store.state.instructor
      }
      if(this.createFlag == 1){
        this.$post('evaluates/create',data).then(res=>{
          if(res.data.status=='success'){
            this.$message({
              message:'评分评价成功！',
              type:'success'
            })
           this.studentMark={
              grade:'',
              comment:'',
            };
            this.dialogVisible = false
            this.createFlag = 0;
            this.beforeUp = {};
            this.getstudentTwo(this.classIdFlag)
            
          }else{
            this.$message({
              message:'评分评价失败！',
              type:'error'
            })
            this.beforeUp = {};
          }
      })
      }
      else if(this.createFlag == 2){
        this.$post('evaluates/edit ',data).then(res=>{
          if(res.data.status=='success'){
            this.$message({
              message:'评分评价修改！',
              type:'success'
            })
           this.studentMark={
              grade:'',
              comment:'',
            };
            this.beforeUp = {};
            this.dialogVisible = false;
            this.createFlag = 0;
            this.getstudentTwo(this.classIdFlag)
            
          }else{
            this.$message({
              message:'评分评价修改失败！',
              type:'error'
            })
            this.beforeUp = {};
          }
      })
      }
      
      
    },
    enter(index) {
      this.seen[index] = true;

    },
    leave(index) {
      this.seen[index] = false;
    },
    //打开学员卡片
    studentCard() {
      UIkit.modal(document.querySelector('#modal-studentCard')).show();
    },

    //获取班级列表
    ClassInquiryTwo() {
      this.$post('class/instructor_search', { token: this.$store.state.instructor, offset: 0, length: 999 }).then(res => {
        this.classlisttwo = res.data.result.data
      })
    },

    //点击获取信息
    Clickdisplay1(banji, index) {
      this.projectDetails={
        period:banji.product_period,
        end_study_time:banji.project_end_study_time,
        end_time:banji.project_end_time,
        name:banji.project_name,
        onsale:banji.project_onsale,
        organizer:banji.project_organizer,
        sponsor:banji.project_sponsor,
        start_stydy_time:banji.project_start_stydy_time,
        start_time:banji.project_start_time
      }
      // 清理项目详情对象
      this.classDetails = {};
      this.id = banji.id;
      this.getstudentTwo(this.id);
      this.getClassinformation();
      //选中变色
      if (this.$refs.light1[index].style.background == '') {
        for (let i of this.$refs.light1) {
          i.style.color = ''
          i.style.background = ''
        }
        this.$refs.light1[index].style.background = '#1e87f1'
        this.$refs.light1[index].style.color = '#ffffff'
      } else if (this.$refs.light[index].style.background != '') {
        this.$refs.light1[index].style.background = '#1e87f1'
        this.$refs.light1[index].style.color = '#ffffff'
      } else {
        this.$refs.light1[index].style.background = ''
        this.$refs.light1[index].style.color = ''
      }
    },

    ////获取班级信息
    getClassinformation() {
      this.$post('class/get', { token: this.$store.state.instructor, id: this.id }).then(res => {
        this.introduction = res.data.result
      })
    },
    //获取成员列表
    getstudentTwo(index) {
      this.classIdFlag = index;
      this.$post('class_users/search', { token:this.$store.state.instructor, offset: 0, length: 500, class_id: index }).then(res => {
        // this.MemberListThree = res.data.result.data;
        // // console.log('成员列表',res)
        this.MemberListTwo = res.data.result.data
      })
    },
    //搜索成员
    toStuList(){
     this.$post('class_users/search', { token: this.$store.state.instructor, offset: 0, length: 500, class_id: this.classIdFlag , user_name: this.classStuSreach }).then(res => {
        this.MemberListTwo = res.data.result.data;
      })
    },

    //搜索班级
    toProductList() {
      this.$post('class/instructor_search', { name: this.classSreach, token: this.$store.state.instructor, offset: 0, length: 100 }).then(res => {
        this.classlisttwo = res.data.result.data;
      })
    },

    //enter键搜索课程
    searchKeyDown(e) {
      if (e.key === 'Enter') {
        this.toProductList();
      }
    },
    searchKeyDown1(e) {
      if (e.key === 'Enter') {
        this.toStuList();
      }
    },

    //点击学生获取改学员的项目进度
    getporject(obj,index) {
      // 清理项目详情对象
      this.classDetails = {};
      this.$post('projects/search', { token: this.$store.state.id, id: this.id }).then(res => {
        // // console.log(JSON.parse(res.data.result.resources))
        this.classDetails = res.data.result
      }).then(resources => {
      })
      // // console.log(JSON.parse(this.MemberListTwo[index].rate) )
      this.outline = JSON.parse(this.MemberListTwo[index].rate) 
      // // console.log( document.getElementsByClassName('center-down')[1].style)
      document.getElementsByClassName('center-down')[1].style.height = (166 * this.outline.length +20) + 'px';

      
    },

    //跳转学生进度详情
    tostudentsmessage(row){
      // // console.log('学生信息',row)
      const {href} = this.$router.resolve({
        path: '/studentsmessage',
        query: {
          purchasedId : row.purchased_id ,
          userId : row.id ,
          classId : row.class_id,
        }
      })
      window.open(href, '_blank')
    }
  },
  mounted() {
    this.ClassInquiryTwo();
  },
}